// extracted by mini-css-extract-plugin
module.exports = {"loginBg":"Login_loginBg__2vixN"};